export enum CodeAssignmentSegmentType {
AutoIncrement,
Manual,
Options,
HardCoded,
}
